import { Expose, Type } from '../../serialization/class-transformer/decorators';
import { LayoutDefinitionIdentity } from './layout-definition.identity';

export class BaseLayoutDataDto {

    @Expose()
    @Type(() => LayoutDefinitionIdentity)
    layoutIdentity?: LayoutDefinitionIdentity;

    @Expose()
    serviceFullName?: string;

}
